
import React from 'react';
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { LucideIcon } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import InstagramPreview from './InstagramPreview';

interface CarouselEntryProps {
  title: string;
  icon: LucideIcon;
  imageUrl: string;
  color: string;
  contentHtml: string;
  isInstagramPreview?: boolean;
  instagramData?: {
    thumbnailUrl: string;
    instagramUrl: string;
  };
}

const CarouselEntry: React.FC<CarouselEntryProps> = ({
  title,
  icon: Icon,
  imageUrl,
  color,
  contentHtml,
  isInstagramPreview = false,
  instagramData
}) => {
  const isMobile = useIsMobile();

  return (
    <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} rounded-lg overflow-hidden`}>
      {/* Example/Visual section - removed bg-neutral-100 */}
      <div className={`${isMobile ? 'h-[30vh]' : 'w-1/2'} relative flex items-center justify-center`}>
        {isInstagramPreview && instagramData ? (
          <div className="py-4 h-full flex items-center justify-center">
            <InstagramPreview
              thumbnailUrl={instagramData.thumbnailUrl}
              instagramUrl={instagramData.instagramUrl}
            />
          </div>
        ) : (
          <AspectRatio ratio={isMobile ? 16/9 : 4/3} className="h-full">
            <img
              src={imageUrl}
              alt={title}
              className="w-full h-full object-contain"
            />
          </AspectRatio>
        )}
      </div>

      {/* Description section */}
      <div className={`${isMobile ? 'w-full' : 'w-1/2'} p-6 md:p-8 flex flex-col justify-center`}>
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
          style={{ backgroundColor: `${color}20` }}
        >
          <Icon size={24} style={{ color: color }} />
        </div>

        <h3 className="text-xl md:text-2xl font-bold mb-3">
          {title}
        </h3>

        <div
          className="text-neutral-600"
          dangerouslySetInnerHTML={{ __html: contentHtml }}
        />
      </div>
    </div>
  );
};

export default CarouselEntry;
